import { render } from "./EstatesMap.vue?vue&type=template&id=4da7f7f2&ts=true"
import script from "./EstatesMap.vue?vue&type=script&lang=ts"
export * from "./EstatesMap.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__